import React from 'react';
import authBg from '../../assets/images/auth/BG.jpg';
import './Auth.styles.css';
import ResetPasswordForm from '../../components/auth/ResetPasswordForm.component';
import ChatHelp from '../../components/chat-help/ChatHelp.component';
import { useTranslation } from 'react-i18next';
import MetaComp from '../../components/meta-comp/MetaComp.component';
import LegalLinks from '../../components/auth/LegalLinks.component';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { getApiUrl } from '../../utils/apiUrls';
import { openSnackBar } from '../../redux/actions/snackbar.actions';
import { apiErrorHandler } from '../../utils/errorHandler';
import MfaForm from '../../components/auth/MfaForm.component';
import ReCAPTCHA from 'react-google-recaptcha';

const ResetPasswordPage = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const refId = searchParams.get("refId");
    const getLang = searchParams.get("lang");
    const clientData = useSelector((state) => state.clientData);
    const appSettings = useSelector(state => state.appSettings)
    const env = useSelector((state) => state?.env);
    const recaptchaRef = React.useRef(null);
    const captchaWidget = React.useMemo(() => {
        if (env?.RECAPTCHA?.ENABLE_RECAPTCHA) {
            return (
                <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={env?.RECAPTCHA?.SITE_KEY}
                    size="invisible"
                    className="cm-recaptcha"
                />
            );
        }
        return null;
    }, [env?.RECAPTCHA?.ENABLE_RECAPTCHA]);
    const [mfadata, setMfadata] = React.useState({
        viaEmail: false,
        viaAuthenticator: false,
        defaultAuthenticationTypeFlag: false,
        emailId: null,
        qrIsSet: false,
        type: "",
        otp: Array(6).fill(""),
        otpHasErrorMsg: "",
        originalAuthenticationType: "",
        isBackButtonStr: "",
        backButtonHistory: {
            type: "",
            defaultAuthenticationTypeFlag: "",
        },
    });
    const [finalData, setFinalData] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const authenticationTypeValue = () => {
        if (mfadata.viaAuthenticator && mfadata.viaEmail) {
            return "EMAIL_AND_AUTHENTICATION_APP";
        } else if (mfadata.viaEmail) {
            return "EMAIL";
        } else {
            return "AUTHENTICATION_APP";
        }
    };

    const actionHandler = (val = null) => {
        if (val === "RESEND_OTP") {
            submitHandler(
                {
                    authenticationType: "EMAIL",
                    username: mfadata.emailId,
                    resend: true,
                },
                2,
                null,
                "RESEND_OTP"
            );

            return;
        }
        const passCode = Number(
            mfadata.otp[0] +
                mfadata.otp[1] +
                mfadata.otp[2] +
                mfadata.otp[3] +
                mfadata.otp[4] +
                mfadata.otp[5]
        );
        switch (mfadata.type) {
            case "FIRST_TIME_LOGIN":
                submitHandler(
                    {
                        authenticationType: authenticationTypeValue(),
                        username: mfadata.emailId,
                    },
                    1
                );
                break;
            case "FIRST_STEP":
                submitHandler(
                    {
                        username: mfadata.emailId,
                        defaultAuthentication: mfadata.defaultAuthenticationTypeFlag,
                        authenticationType: mfadata.viaEmail
                        ? "EMAIL"
                        : "AUTHENTICATION_APP",
                    },
                    2,
                    {
                        type: mfadata.viaEmail ? "SECOND_STEP_EMAIL" : "SECOND_STEP_APP",
                    }
                );
                break;
            case "SECOND_STEP_EMAIL":
                if (passCode.toString().length !== 6) {
                    setMfadata({
                        ...mfadata,
                        otpHasErrorMsg: "opt_should_have_six_number",
                    });
                    return;
                }
                submitHandler(
                    {
                        actionType: "EMAIL",
                        username: mfadata.emailId,
                        passCode: Number(passCode),
                    },
                    3
                );
                break;
            case "SECOND_STEP_APP":
                if (passCode.toString().length !== 6) {
                    setMfadata({
                        ...mfadata,
                        otpHasErrorMsg: "opt_should_have_six_number",
                    });
                    return;
                }
                submitHandler(
                    {
                        actionType: "AUTHENTICATION_APP",
                        username: mfadata.emailId,
                        passCode: Number(passCode),
                    },
                    3
                );
                break;
            default: return null
        }
    };
    const mfadataHandler = (val) => {
        setMfadata({ ...mfadata, ...val });
    };

    const submitHandler = async (
        data,
        stepper,
        appendMfaData = null,
        actionType
    ) => {
        try {
            if (isLoading) return;

            let recaptchaToken = null;
            if (stepper === 0 && env?.RECAPTCHA?.ENABLE_RECAPTCHA) {
                recaptchaToken = await recaptchaRef.current.executeAsync();
                recaptchaRef.current?.reset();
                if (!recaptchaToken) {
                    dispatch(openSnackBar({ msg: t('captcha_verification_failed'), type: 'error' }));
                    return;
                }
            }

            setIsLoading(true);

            const loginData = await axios.post(
                `${getApiUrl("forgotPasswordMfaCheck")}?stepper=${stepper}`,
                { ...data, refId, getLang, mettlClientName: clientData?.clientName ? clientData?.clientName : null, ...(stepper === 0 ? { recaptchaToken } : {}) }
            );

            if(loginData.data.status === "SUCCESS" && loginData.data.message) {
                dispatch(openSnackBar(
                    {
                    msg: t(loginData.data.message),
                    type: 'success'
                }));
                setIsLoading(false);

                setMfadata({
                    viaEmail: false,
                    viaAuthenticator: false,
                    defaultAuthenticationTypeFlag: false,
                    emailId: null,
                    qrIsSet: false,
                    type: "",
                    otp: Array(6).fill(""),
                    otpHasErrorMsg: "",
                    originalAuthenticationType: "",
                    isBackButtonStr: "",
                    backButtonHistory: {
                        type: "",
                        defaultAuthenticationTypeFlag: "",
                    },
                });
                setFinalData(null);

                return;
            }

            if(stepper === 0) {
                setFinalData(data)
            }

            if(stepper === 3 || (stepper === 0 && (loginData.data.authenticationRequired === false && loginData.data.authenticationType === null))) {
                const dataToSend = stepper === 0 ? {email: data.username, refId: data?.refId ? data.refId : null } : { email: finalData.username, refId: finalData?.refId ? finalData.refId : null }
                const res = await axios.post(`${getApiUrl('forgotPassword')}?lang=${appSettings?.lang ? appSettings?.lang : ''}`, dataToSend);
                if(res.data.status === "SUCCESS") {
                    setIsLoading(false);

                    dispatch(openSnackBar(
                        {
                        msg: t(res.data.message),
                        type: 'success'
                    }));

                    setMfadata({
                        viaEmail: false,
                        viaAuthenticator: false,
                        defaultAuthenticationTypeFlag: false,
                        emailId: null,
                        qrIsSet: false,
                        type: "",
                        otp: Array(6).fill(""),
                        otpHasErrorMsg: "",
                        originalAuthenticationType: "",
                        isBackButtonStr: "",
                        backButtonHistory: {
                            type: "",
                            defaultAuthenticationTypeFlag: "",
                        },
                    });
                    setFinalData(null);

                    return;
                }
            }

            // const loginData = {
            //     data: {
            //         "authenticationRequired": true,
            //         "defaultAuthenticationType": null,
            //         "mfaDate": 1749686400,
            //         "authenticationType": null,
            //         "candidateId": 233
            //     }
            // }
            if (loginData.data?.jwtToken) {
                if (!!getLang) {
                // saveUser(loginData.data?.jwtToken, getLang);
                } else {
                // saveUser(loginData.data?.jwtToken, null);
                }
            } else if (stepper === 0) {
                // WHEN USER WRITE EMAIL AND PASSWORD
                let type;
                let temp = {};
                if (
                    loginData.data.authenticationType === null || loginData.data.authenticationType === "EMAIL" ||
                    loginData.data.defaultAuthenticationType === "EMAIL"
                ) {
                    submitHandler(
                        {
                            defaultAuthentication:
                                !!loginData?.data?.defaultAuthenticationType,
                            authenticationType: "EMAIL",
                            username: data.username,
                        },
                        2
                    );
                    temp = { viaEmail: true };
                    type = "SECOND_STEP_EMAIL";
                } else if (
                    loginData.data.authenticationType === "AUTHENTICATION_APP" ||
                    loginData.data.defaultAuthenticationType === "AUTHENTICATION_APP"
                ) {
                    temp = { viaAuthenticator: true };
                    type = "SECOND_STEP_APP";
                } else if (loginData.data.authenticationType === "EMAIL_AND_AUTHENTICATION_APP") {
                    type = "FIRST_STEP";
                }
                if (loginData.data.defaultAuthenticationType === "EMAIL") {
                    temp = { viaEmail: true };
                } else if (
                    loginData.data.defaultAuthenticationType === "AUTHENTICATION_APP"
                ) {
                    temp = { viaAuthenticator: true };
                }
                setMfadata({
                    ...mfadata,
                    mfaDate: loginData.data.mfaDate,
                    defaultAuthenticationType: loginData.data.defaultAuthenticationType,
                    defaultAuthenticationTypeFlag:
                        !!loginData.data.defaultAuthenticationType,
                    originalAuthenticationType: loginData.data.authenticationType,
                    emailId: data.username,
                    candidateId: loginData.data.candidateId,
                    type,
                    ...temp,
                });
            }
            if (stepper === 2) {
                if (!!appendMfaData) {
                    setMfadata({
                        ...mfadata,
                        ...appendMfaData,
                    });
                } else if (actionType === "RESEND_OTP") {
                    dispatch(
                        openSnackBar({
                        msg: t("resend_otp_send_sucessfully"),
                        type: "success",
                        })
                    );
                }
            }
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
            const errObj = apiErrorHandler(err);
            if (stepper === 0) {
                if (errObj.statusText === "account_not_activated") {
                    dispatch(
                        openSnackBar({
                        msg: t("account_not_activated"),
                        type: "error",
                        })
                    );
                    return;
                }
            } else if (stepper === 3) {
                if(errObj.statusText === "otp_invalid") {
                    setMfadata({
                        ...mfadata,
                        otpHasErrorMsg: "invalid_passcode_please_try_again",
                    });
                    dispatch(
                        openSnackBar({
                            msg: t("invalid_passcode_please_try_again"),
                            type: "error",
                        })
                    );
                } else {
                    dispatch(openSnackBar({
                        msg: t(errObj.statusText),
                        type: 'error'
                    }));
                    setMfadata({
                        viaEmail: false,
                        viaAuthenticator: false,
                        defaultAuthenticationTypeFlag: false,
                        emailId: null,
                        qrIsSet: false,
                        type: "",
                        otp: Array(6).fill(""),
                        otpHasErrorMsg: "",
                        originalAuthenticationType: "",
                        isBackButtonStr: "",
                        backButtonHistory: {
                            type: "",
                            defaultAuthenticationTypeFlag: "",
                        },
                    });
                    setFinalData(null);
                }
                return;
            } else if (errObj.statusText === "otp_already_send") {
                dispatch(
                    openSnackBar({
                        msg: t("resend_otp_send_sucessfully"),
                        type: "success",
                    })
                );
                return;
            }
            if (err.response?.data?.status === 401) {
                dispatch(
                    openSnackBar({
                        msg: t(err.response.data.details[0]),
                        type: "error",
                    })
                );
            } else {
                dispatch(
                    openSnackBar({
                        msg: t(errObj.statusText),
                        type: "error",
                    })
                );
            }
        }
    };
    const subTextHandler = () => {
        if (!!mfadata?.type && mfadata.type === "FIRST_TIME_LOGIN") {
        return t("choose_set_multi_factor_authentication");
        }
        if (
        !!mfadata?.type &&
        (mfadata.type === "SECOND_STEP_EMAIL" ||
            mfadata.type === "SECOND_STEP_APP" ||
            mfadata.type === "FIRST_STEP")
        ) {
        return t("mfa_verification_method");
        }
        return t("please_enter_emailId");
    };

    return(
        <main className='cm-page-container cm-auth-page-container d-flex row mx-0'>
            <MetaComp title={t("reset_password_page_title")}/>
            <div className='col-sm-12 col-md-6  cm-auth-content-wrap d-flex flex-column'>
                <div className='cm-auth-content-inner col-12 flex-grow-1 d-flex flex-column justify-content-center'>
                    <div>
                        <div className="cm-txt-wrap">
                            <h2 className='h2 text-blue-gray-700  cm-fs-24 cm-mmc-font'>{t("need_help")} <span className='d-block h1 text-primary fw-bold cm-fs-40'>{t("reset_your_password")}</span></h2>
                            <h4 className='h4 text-blue-800'>{subTextHandler()}</h4>
                        </div>

                        <hr className='cm-auth-hr bg-blue-gray-300' />
                        
                        {!mfadata?.type ? <ResetPasswordForm t={t} submitHandler={submitHandler} isLoading={isLoading} /> : <MfaForm
                            actionHandler={actionHandler}
                            mfadata={mfadata}
                            mfadataHandler={mfadataHandler}
                            skipForNowHandler={null}
                        />}
                    </div>
                </div>
                <LegalLinks />
            </div>
            <div className='col-sm-6 py-8 cm-auth-bg-container position-relative d-none d-lg-block d-md-block w-md-50' style={{ backgroundImage: `url('${authBg}')` }}>
                <ChatHelp />
            </div>
            {captchaWidget}
        </main>
    )

}

export default ResetPasswordPage;